<template>
  <div class="kiw-edit">
    <app-view-layout header="Edycja wniosku KIW">
      <template #content>
        <v-form
          ref="editKIWForm"
          v-model="isFormValid"
          lazy-validation
          @submit.prevent="submit"
        >
          <KIWFormCard
            v-model="tempKiw"
            class="mt-4 mb-8"
          />

          <TemplatesArchive
            v-model="tempKiw.projectId"
            :template-type="'Project'"
            projects-only
          />

          <AppTextCard
            v-model="tempKiw.notes"
            class="mb-8"
            title="Komentarz"
          />

          <ProjectFilesCard
            ref="kiwFiles"
            :files="kiw.files || []"
            hide-tabs
            kiw-files
            :processing="isProcessing"
            @add="showFileAddDialog"
            @delete="confirmDeleteFiles"
          />

          <v-btn
            class="my-8"
            color="primary"
            type="submit"
            height="40"
            max-width="120"
            :loading="isProcessing"
          >
            Zapisz wniosek
          </v-btn>
        </v-form>
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import validationRules from '@/helpers/validators';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import KIWFormCard from '@/components/KIW/KIWFormCard.vue';
import TemplatesArchive from '@/components/Projects/TemplatesArchive.vue';
import AppTextCard from '@/components/UI/AppTextCard.vue';
import ProjectFilesCard from '@/components/Projects/ProjectFilesCard.vue';

export default {
  components: {
    AppViewLayout,
    KIWFormCard,
    TemplatesArchive,
    AppTextCard,
    ProjectFilesCard,
  },

  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },

  data() {
    return {
      rules: validationRules,
      isFormValid: true,
      tempKiw: {
        notes: '',
      },
    };
  },

  computed: {
    ...mapState('kiwSingle', [
      'isProcessing',
      'kiw',
    ]),
  },

  created() {
    this.fetchSingleKIW(this.id)
      .then((kiw) => {
        this.tempKiw = kiw;
        this.selectTemplate(kiw.project);
      });
  },

  beforeDestroy() {
    this.resetSingleKIW();
    this.changeProcessingStatus(false);
  },

  methods: {
    ...mapActions('kiwSingle', [
      'editSingleKIW',
      'destroyKIWFiles',
      'changeProcessingStatus',
      'fetchSingleKIW',
      'resetSingleKIW',
    ]),
    ...mapActions('dialog', [
      'showDialog',
    ]),
    ...mapActions('snackbar', [
      'showSnackbar',
    ]),

    submit() {
      this.$refs.editKIWForm.validate();

      if (this.isFormValid) {
        this.editSingleKIW(this.tempKiw);
      } else {
        this.$vuetify.goTo(0);
        this.showSnackbar({
          message: ['Występują błędy/braki w formularzu'],
          type: 'error',
        });
      }
    },

    selectTemplate(template) {
      this.tempKiw.projectId = template?.id || null;
    },

    showFileAddDialog() {
      this.showDialog({
        header: 'Dodawanie pliku/ów',
        text: 'Wybierz plik/i i dodaj do wniosku KIW.',
        component: 'FileUpload',
        props: {
          kiwFile: true,
        },
      });
    },

    confirmDeleteFiles(fileIds) {
      this.destroyKIWFiles(fileIds)
        .then(() => {
          this.$refs.kiwFiles.clearSelection();
        });
    },
  },
};
</script>
